import { render, staticRenderFns } from "./setMsg.vue?vue&type=template&id=57f8dd36&scoped=true"
import script from "./setMsg.vue?vue&type=script&lang=js"
export * from "./setMsg.vue?vue&type=script&lang=js"
import style0 from "./setMsg.vue?vue&type=style&index=0&id=57f8dd36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f8dd36",
  null
  
)

export default component.exports